<template>
  <div class="pa-3">
    <loader v-if="$wait.is('getPublishers')"></loader>
    <v-container v-else>
      <div class="d-flex flex-column">
        <div style="width: 100%" :class="hasAdminRights && getDeviceType === 'touch' ? 'd-flex justify-space-between' : ''">
          <span class="headline font-weight-light d-flex"> Izdavači <span class="d-flex pl-1" v-html="izdavaciTotal"></span></span>
          <v-btn
            v-show="hasAdminRights && getDeviceType === 'touch'"
            @click="openNovi"
            fab
            elevation="0"
            color="primary" 
            x-small
          >
          <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
        <div
          class="d-flex justify-space-between"
          :class="$vuetify.breakpoint.mdAndUp ? '' : 'flex-column'"
        >
          <div
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'min-width: 400px; max-width: 800px'
                : 'width:100%'
            "
          >
            <v-text-field
              dense
              label="Traži"
              v-model="searchPublisher"
              outlined
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </div>
          <v-btn
            v-show="hasAdminRights && getDeviceType != 'touch'"
            color="primary"
            dark
            class="mb-2"
            @click="openNovi"
            >Dodaj izdavača</v-btn
          >
          
        </div>
      </div>
      <v-data-table
        :loading="$wait.is('publishers')"
        :headers="headers"
        :search="searchPublisher"
        :items="publishers"
        :items-per-page="getPublishers.per_page"
        hide-default-footer
        class="elevation-1 curs"
        no-data-text="Nema podataka"
        no-results-text="Nema podataka"
        loading-text="Učitavanje..."
      >
        <template v-if="hasAdminRights" v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                @click="editIzdavac(item)"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Uredi</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                @click="deleteItem(item)"
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Izbriši</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          v-model="page"
          @input="goTo"
          :length="getPublishers.last_page"
          total-visible="20"
        ></v-pagination>
      </div>
      <v-dialog v-model="noviIzdavac" max-width="500px">
        <Dialog
          :searchPublisher="searchPublisher"
          :isSelectable="selectable"
          :naziv="naziv"
          :selectedCountry="selectedCountry"
          :inEdit="inEdit"
          :selectedPublisher="selectedPublisher"
          v-on:closeDialog="closeDialog"
          v-on:setNaziv="setNaziv"
          v-on:setDrzava="setDrzava"
        />
      </v-dialog>
      <v-dialog
        v-model="deleteDialog"
        persistent
        no-click-animation
        max-width="290"
      >
        <v-card :loading="$wait.is('deletePublisher')">
          <v-card-title class="headline">Izbriši izdavača</v-card-title>
          <v-card-text
            >Da li ste sigurni da želite izbrisati izdavača?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              :disabled="$wait.is('deletePublisher')"
              @click="deleteDialog = false"
              >Ne</v-btn
            >
            <v-btn
              color="red darken-1"
              text
              :disabled="$wait.is('deletePublisher')"
              @click="Delete"
              >Izbriši</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";
import Dialog from "../components/IzdavaciDialog";
export default {
  metaInfo: {
    title: "Izdavači  - Registar radova",
  },
  components: {
    Dialog,
  },
  data: () => ({
    name: "Izdavaci",

    selectable: false,
    search: "",
    headers: [
      {
        text: "Naziv",
        align: "start",
        sortable: false,
        value: "naziv",
      },
      { text: "Država", value: "drzava", align: "start", sortable: false },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],
    inEdit: false,
    noviIzdavac: false,
    selectedCountry: null,
    naziv: "",
    selectedPublisher: {},
    deleteDialog: false,
    selectedForDelete: {},
    page: 1,
  }),

  computed: {
    ...mapGetters([
      "getCountries",
      "getPublishers",
      "hasAdminRights",
      "getDeviceType",
    ]),
    publishers() {
      let publishers = [];
      if (this.getPublishers.data && this.getCountries.data) {
        this.getPublishers.data.forEach((pub) => {
          let drzava = this.getCountries.data.find(
            (co) => co.id == pub.drzava_id
          ).naziv;
          Object.assign(pub, { drzava: drzava });
          publishers.push(pub);
        });
      }
      return publishers;
    },
    searchPublisher: {
      set(value) {
        if (value != this.search) {
          this.search = value;
          waitFor("publishers", async function () {
            await this.$store.dispatch("getPublishers", {
              page: 1,
              search: value,
            });
          }).apply(this);
        }
      },
      get() {
        return this.search;
      },
    },
    izdavaciTotal(){
       return parseInt(this.getPublishers.total)? '(<p class="" style="color: var(--v-primary-base)" id="numberOf">'+parseInt(this.getPublishers.total)+'</p>)': ''
    }
  },

  methods: {
    openNovi() {
      this.noviIzdavac = true;
    },
    deleteItem(item) {
      this.selectedForDelete = item;
      this.deleteDialog = true;
    },
    goTo(item) {
      this.page = item;
      waitFor("publishers", async function () {
        await this.$store.dispatch("getPublishers", {
          page: item,
          search: this.searchPublisher,
        });
      }).apply(this);
    },
    Delete() {
      waitFor("deletePublisher", async function () {
        await this.$store
          .dispatch("deletePublisher", this.selectedForDelete.id)
          .then(() => {
            this.selectedForDelete = {};
            this.deleteDialog = false;
            this.$store.dispatch("getPublishers", {
              page: this.page,
              search: this.searchPublisher,
            });
          });
      }).apply(this);
    },

    editIzdavac(izdavac) {
      this.selectedCountry = this.getCountries.data.find(
        (co) => co.id == izdavac.drzava_id
      );
      this.naziv = izdavac.naziv;
      this.selectedPublisher = izdavac;
      this.inEdit = true;
      this.noviIzdavac = true;
    },
    closeDialog() {
      this.noviIzdavac = false;
      this.naziv = "";
      this.inEdit = false;
      this.selectedPublisher = null;
      this.selectedCountry = null;
    },
    setNaziv(value) {
      this.naziv = value;
    },
    setDrzava(value) {
      this.selectedCountry = value;
    },
  },
  beforeCreate() {
    waitFor("getPublishers", async function () {
      await this.$store.dispatch("getPublishers", { page: 1, search: "" });
    }).apply(this);
  },
};
</script>

<style lang="scss">
.curs > .v-data-table__wrapper > table tbody td {
  cursor: context-menu !important;
}
</style>